const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NOGA-desna") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M228.1,366.9c12.6-3,17.6,5.8,16.7,9.4-1.2,11.2-11.9,12.1-15.6,8-5.6,9.1,13.1,27.3,2.4,32.8-13.6,6.9-15.6-8.4-15.4-7.7,2.6,10.5-13.7,7.2-14.6-4-.6-7.4,6.2-11.7,14.2-10.3,2.6.7,1.9-7,3.2-9.7C223.2,388,222.7,370.8,228.1,366.9Z",
    style: {
      fill: "#f99422",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,379.5c-7.7,1.1-15,8.2-11.1,18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 8.569999694824219,
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,402.4a6,6,0,0,0-8.1-.4,6.73,6.73,0,0,0-1.3,8.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3575999736785889px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootRight);
export default __webpack_public_path__ + "static/media/foot-right.a3b90f5cfb82d4ca9dedc8095ddd40e0.svg";
export { ForwardRef as ReactComponent };